<template>
  <div class="face-recognition">
    <div class="content">
      <div class="title">请使用电子税局APP或个税APP扫码认证</div>
      <div class="describe">
        APP认证成功后手动关闭弹窗即可，认证频次建议根据电子税局设置为准，频繁认证可能会有被税局拉黑的风险，请您知悉，
        <span class="tip" @click="handleGoTip">如何设置认证频次</span>
      </div>
      <van-radio-group class="radio-group" :value="faceQrCodeType" direction="horizontal">
        <van-radio icon-size="16" :name="0" @click="() => handleRadioClick(0)">电子税局APP</van-radio>
        <van-radio icon-size="16" :name="1" @click="() => handleRadioClick(1)">个人所得税APP</van-radio>
      </van-radio-group>
      <div class="two-dimensional-code">
        <QRcode v-if="qrcodeUrl" ref="qrCode" width="400" height="400" title="二维码" :url="qrcodeUrl"/>
        <div class="code" v-else></div>
        <div class="refresh" @click="handleRefreshQr">刷新二维码</div>
        <div class="result">
          <div>
            <div class="label">认证ID：</div>
            <div class="value">{{ certificationResults.authenticationId || '--' }}</div>
          </div>
          <div>
            <div class="label">生成时间：</div>
            <div class="value">{{ certificationResults.generateDate || '--' }}</div>
          </div>
          <div>
            <div class="label">扫码方式：</div>
            <div class="value">{{ certificationResults.faceQrCodeType ? Number(certificationResults.faceQrCodeType) === 1 ? '个人所得税APP' : '电子税局APP' : '电子税局APP' }}</div>
          </div>
          <div>
            <div class="label">认证结果：</div>
            <div class="value">{{ renderResultsMap(certificationResults.authenticationResult) }}</div>
          </div>
        </div>
        <div class="get-result" @click="handleGetResult">获取人脸认证结果</div>
      </div>
    </div>
    <div class="footer">
      <van-button
        class="btn"
        :loading="btnLoading"
        type="info"
        loading-text="保存中..."
        @click="handleSaveImg"
      >
        保存到相册
      </van-button>
    </div>
  </div>
</template>

<script>
import { RadioGroup, Radio, Button, Toast, Notify } from 'vant'
import { mapActions, mapState, mapMutations } from 'vuex'
import { getWebCache } from '@/utils/basicUtil.js'
const namespace = 'faceRecognitionModel'
export default {
  components: {
    [RadioGroup.name]: RadioGroup,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Radio.name]: Radio
  },
  computed: {
    ...mapState(namespace, ['qrcodeUrl', 'certificationResults']),
    renderResultsMap () {
      return (type) => {
        const resultsMap = {
          1: '未认证',
          2: '已认证',
          0: '未获取',
          '99': '获取失败，请重试或刷新二维码'
        }
        return [0, 1, 2].includes(Number(type)) ? resultsMap[Number(type)] : resultsMap['99']
      }
    }
  },
  data () {
    return {
      btnLoading: false,
      faceQrCodeType: 0
    }
  },
  async mounted () {
    this.faceQrCodeType = getWebCache('faceQrCodeType') || 0
    this.setCertificationResults({})
    await this.handleGetQrCode(0, this.faceQrCodeType)
  },
  methods: {
    ...mapActions(namespace, ['getQrCode', 'getResult']),
    ...mapMutations(namespace, ['setCertificationResults']),
    handleGoTip () {
      window.open('https://www.yuque.com/huisuiyun/zo3as1/mmyk0qpoorgimxq2')
    },
    async handleGetResult () {
      if (this.certificationResults.authenticationResult && Number(this.certificationResults.authenticationResult) === 2) {
        return Notify({ type: 'danger', message: '已扫脸认证成功，无需再次查看结果!' })
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      await this.getResult({ faceQrCodeType: this.faceQrCodeType })
      Toast.clear()
    },
    async handleGetQrCode (refreshType = 0, faceQrCodeType) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      await this.getQrCode({ refreshType, faceQrCodeType })
      Toast.clear()
    },
    handleSaveImg () {
      if (this.$refs['qrCode']) {
        this.$refs['qrCode'].$emit('downloadQrCode')
      }
    },
    handleRadioClick (type) {
      this.faceQrCodeType = type
      this.handleGetQrCode(0, type)
    },
    handleRefreshQr () {
      this.handleGetQrCode(1, this.faceQrCodeType)
    }
  }
}
</script>
<style scoped lang='less'>
.face-recognition{
  width: 100%;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  border-top: 1px solid rgb(224, 219, 219);
  .content{
    flex-grow: 1;
  }
  .refresh {
    margin-bottom: 12px;
    color: #297CF0;
    font-size: 28px;
  }
  .footer{
    margin: 24px 0;
    .btn{
      padding: 16px 0;
      width: 100%;
      height: 100%;
      border-radius: 40px;
      font-size: 32px;
    }
  }
  .radio-group{
    font-size: 32px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .title, .describe{
    color: #000;
  }
  .two-dimensional-code{
    .code{
      width: 400px;
      height: 400px;
    }
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .get-result{
      font-size: 28px;
      justify-content: center;
      color: #297CF0;
    }
    .result{
      width: 88%;
      margin: 0 auto;
      padding: 14px;
      box-sizing: border-box;
    }
    .result > div{
      display: flex;
      margin-bottom: 16px;
      font-size: 28px;
      .label{
        width: 160px;
      }
      .value{
        flex-grow: 1;
        width: 0;
        word-wrap: break-word;
      }
    }
    .qrcode{
      width: 520px;
      height: 520px;
    }
  }
  .title {
    margin-top: 38px;
    font-size: 38px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  .describe {
    margin-top: 60px;
    font-size: 28px;
    font-weight: 400;
    color: #666;
    .tip{
      color: #297CF0;
    }
  }
}
</style>
